const proxyURL = process.env.REACT_APP_PROXY_URL;
const prod = process.env.REACT_APP_RUN_ENV === "prod";

export const colorKeywordToRGB = (colorKeyword) => {

    // CREATE TEMPORARY ELEMENT
    let el = document.createElement('div');

    // APPLY COLOR TO TEMPORARY ELEMENT
    el.style.color = colorKeyword;

    // APPEND TEMPORARY ELEMENT
    document.body.appendChild(el);

    // RESOLVE COLOR AS RGB() VALUE
    let rgbValue = window.getComputedStyle(el).color;

    // REMOVE TEMPORARY ELEMENT
    document.body.removeChild(el);
    // console.log(rgbValue)
    return rgbValue;
}

export const rgbBackgroundToTextColor = (rgbString) => {
    
    const [red, green, blue] = rgbString.replace(/[^\d,]/g, '').split(',');
    // console.log({red, green, blue})
    // console.log((red*0.299 + green*0.587 + blue*0.114) > 186 ? "#000000" : "#ffffff")
    return (red*0.299 + green*0.587 + blue*0.114) > 186 ? "#000000" : "#ffffff"
}


export function parseXml(xml, arrayTags) {
    let dom = null;
    if (window.DOMParser) dom = (new DOMParser()).parseFromString(xml, "text/xml");
    else if (window.ActiveXObject) {
        dom = new window.ActiveXObject('Microsoft.XMLDOM');
        dom.async = false;
        if (!dom.loadXML(xml)) throw new Error(dom.parseError.reason + " " + dom.parseError.srcText);
    }
    else throw new Error("cannot parse xml string!");

    function parseNode(xmlNode, result) {
        if (xmlNode.nodeName === "#text") {
            let v = xmlNode.nodeValue;
            if (v.trim()) result['#text'] = v;
            return;
        }

        let jsonNode = {},
            existing = result[xmlNode.nodeName];
        if (existing) {
            if (!Array.isArray(existing)) result[xmlNode.nodeName] = [existing, jsonNode];
            else result[xmlNode.nodeName].push(jsonNode);
        }
        else {
            if (arrayTags && arrayTags.indexOf(xmlNode.nodeName) !== -1) result[xmlNode.nodeName] = [jsonNode];
            else result[xmlNode.nodeName] = jsonNode;
        }

        if (xmlNode.attributes) for (let attribute of xmlNode.attributes) jsonNode[attribute.nodeName] = attribute.nodeValue;

        for (let node of xmlNode.childNodes) parseNode(node, jsonNode);
    }

    let result = {};
    for (let node of dom.childNodes) parseNode(node, result);

    return result;
}


export const ticketCookieName = "TICKET_atlas-titan.quickbase.com"



export const getCookieValue = (name) => document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop();// || ''


export const pFetch = (url, options, ...rest) => {
  if(!prod) {
    const newURL = new URL(url);
    return fetch((newURL.pathname+newURL.search), options, ...rest)
  } else {

    const {headers, credentials, body} = (options || {});
    const contentType = options?.headers?.["Content-Type"];
    
    const newOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      }
    }
    const newBody = {}
    const realBody = {url, token: ""}
    // if(!prod) newOptions.mode = "cors";
    if(headers) newBody.headers = {...headers, ...(contentType === "application/json" ? {referer: "https://atlas-titan.quickbase.com"} : {})};
    
    if(credentials === "include") {
      newBody.cookies = {
        [ticketCookieName]: getCookieValue(ticketCookieName),
        "TICKET": getCookieValue(ticketCookieName)
      }
    }
    if(body) newBody.data = body;
    realBody.opts = newBody;
    newOptions.body = JSON.stringify(realBody);
    // let newURL = url.split(".com/")[1];
    return fetch(`https://saferightfast.app/api/proxy/${options?.method?.toLowerCase() || "get" }`, newOptions).then(res => Promise.all([res, res.json()])).then(([res, resText]) => new Response(resText, {...res}));
  }
}



// export const dirtySignIn = async () => {
//     let authed;
//     while(!authed) {
//     //   let username; 
//     //   while(!username) {
//         let username = window.prompt("Enter Username or Email");
//         if(!username) return; 
//     //   }
//     //   let password; 
//     //   while(!password) {
//         let password = window.prompt("Enter Password");
//         if(!password) return; 
//     //   }
  
//       let hours = Number(window.prompt("How many hours would you like to stay signed in? \n\n (Leave blank for session)")) || 0;
//         console.log(hours)
//       let req = await auth(username, password, hours);
//       if(req.ok) {
//         authed = true;
//         window.alert("You're signed in!");
//       } else {
//         window.alert("ERROR \n\n" + req.body)
//       }
//     }
//   }


// export function replacePage(pageName) {
//   const url = new URL(window.location)
//   url.searchParams.set("page", String([pageName]));
//   window.history.replaceState({}, "", url);
// }

// export function changePage(pageName) {
//   const url = new URL(window.location)
//   url.searchParams.set("page", String([pageName]));
//   window.history.pushState({}, "", url);
// }